import { gql } from '@apollo/client';
import { INom } from 'types/datatypes/INom';
import { createDataSource } from 'utils/gql-datasource';

const dsGetServicesNoms = gql(`query dsGetServisesNoms($ref: String, $offset: Int, $limit: Int, $jfilt: [JSON], $jfiltJoined: [JSON], $userData: JSON) {
    totalcount: noms(ref: $ref, totalCount: 1, jfilt: $jfilt, jfiltJoined: $jfiltJoined, userData: $userData) { totalcount }
    list: noms(ref: $ref, limit: $limit, offset: $offset, jfilt: $jfilt, jfiltJoined: $jfiltJoined, userData: $userData) {
      ref
      name
      name_full
      vat_rate
      article
      doc_type
      nom_type
    }
  }`);

export const dsServicesNoms = createDataSource<INom>(dsGetServicesNoms);
// store.jfiltJoined має пріоритет над переданим у load(), тож умова діє на кожен
// запит - фільтр по приєднаному cat.nom_kinds (працює лише тому, що запит вибирає
// nom_kind {...}, інакше на сервері немає JOIN-аліаса, під який підставити умову).
// dsServicesNoms.jfiltJoined = [ { fld: 'nom_kind.nom_type', expr: '=', val: 'Услуга' } ];
// постійна умова по полях номенклатури - onLoading зливає її з фільтром пошуку
dsServicesNoms.filter([ [ 'nom_type', '=', 'Услуга' ], 'and', 'not', [ 'proj', 'is', null ] ] );

